import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';

export type IDivider = IBlockData<
    {
        'border-color'?: string;
        'border-style'?: string;
        'border-width'?: string;
        'container-background-color'?: string;
        width?: string;
        align?: 'left' | 'center' | 'right';
        padding?: string;
    },
    {}
>;

export const Divider = createBlock<IDivider>({
    get name() {
        return t('Divider');
    },
    type: BasicType.DIVIDER,
    create: (payload: any) => {
        const defaultData: IDivider = {
            type: BasicType.DIVIDER,
            data: {
                value: {},
            },
            attributes: {
                align: 'center',
                'border-width': '1px',
                'border-style': 'solid',
                'border-color': '#C9CCCF',
                padding: '10px 0px 10px 0px',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.COLUMN, BasicType.HERO],
    render(params: any) {
        return <BasicBlock params={params} tag="mj-divider" />;
    },
});
